import { useMemo } from 'react';
import * as THREE from 'three';
import { GLOBE_RADIUS } from './geo';

/** A thin Fresnel rim — one draw call, no texture. Reads as a soft edge of
 *  air, not a neon halo. */
export function Atmosphere() {
  const material = useMemo(
    () =>
      new THREE.ShaderMaterial({
        transparent: true,
        side: THREE.BackSide,
        depthWrite: false,
        blending: THREE.NormalBlending,
        uniforms: {
          uColor: { value: new THREE.Color('#6fa7d8') },
          uIntensity: { value: 0.22 },
        },
        vertexShader: /* glsl */ `
          varying vec3 vNormal;
          varying vec3 vView;
          void main() {
            vNormal = normalize(normalMatrix * normal);
            vec4 mv = modelViewMatrix * vec4(position, 1.0);
            vView = normalize(-mv.xyz);
            gl_Position = projectionMatrix * mv;
          }
        `,
        fragmentShader: /* glsl */ `
          uniform vec3 uColor;
          uniform float uIntensity;
          varying vec3 vNormal;
          varying vec3 vView;
          void main() {
            // BackSide: strongest where the (flipped) normal grazes the view
            float f = pow(1.0 - abs(dot(vNormal, vView)), 4.5);
            gl_FragColor = vec4(uColor, f * uIntensity);
          }
        `,
      }),
    [],
  );

  return (
    <mesh scale={1.016} material={material}>
      <sphereGeometry args={[GLOBE_RADIUS, 64, 64]} />
    </mesh>
  );
}
